import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import './blockTextFullwidthCarousel.scss'

function BlockTextFullwidthCarousel(data: {
  title: string
  subtitle: string
  btnText: string
  btnBackground: string
  btnColorText: string
  btnBorder: string
  btnLink: string
  textColor: string
  componentLayout: string
}) {
  const {
    title,
    subtitle,
    btnText,
    btnBackground,
    btnColorText,
    btnBorder,
    btnLink,
    textColor,
    componentLayout,
  } = data

  const [isMobile, setIsMobile] = useState<boolean>(true)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setIsMobile(window?.innerWidth < 660)
      window.addEventListener('resize', () =>
        setIsMobile(window?.innerWidth < 660)
      )
    }
  }, [])

  return (
    <div className="blocktext-fullwidthCarousel-container">
      <div>
        <h1
          className={`blocktext-fullwidthCarousel-title ${
            componentLayout === 'life' ? 'life' : 'vivara'
          }`}
          style={{ color: textColor }}
        >
          {title}
        </h1>
        <h2
          className="blocktext-fullwidthCarousel-subtitle"
          style={{ color: textColor }}
        >
          {subtitle}
        </h2>
        <div
          className="blocktext-fullwidthCarousel-border"
          style={{ borderColor: textColor }}
        />
        {isMobile ? (
          <Link
            className="blocktext-fullwidthCarousel-link"
            to={btnLink}
            style={{
              backgroundColor: 'transparent',
            }}
          >
            <button
              className="blocktext-fullwidthCarousel-button"
              style={{
                color: btnColorText,
              }}
            >
              {btnText}
            </button>
          </Link>
        ) : (
          <Link
            className="blocktext-fullwidthCarousel-link"
            to={btnLink}
            style={{
              backgroundColor: btnBackground,
              borderColor: btnBorder,
            }}
          >
            <button
              className="blocktext-fullwidthCarousel-button"
              style={{
                color: btnColorText,
              }}
            >
              {btnText}
            </button>
          </Link>
        )}
      </div>
    </div>
  )
}

export default BlockTextFullwidthCarousel
